import { useEffect, useState } from "react";

import { getSupabaseClient } from "../providers/supabase/supabase";
import { CONTENT_BUCKET } from "./pieceModel";

const SIGNED_URL_SECONDS = 60 * 60;

/** Short-lived URL for a private file (content bucket by default). */
export const useSignedUrl = (
  path?: string | null,
  bucket: string = CONTENT_BUCKET,
): string | null => {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!path) return;
    let isCurrent = true;
    getSupabaseClient()
      .storage.from(bucket)
      .createSignedUrl(path, SIGNED_URL_SECONDS)
      .then(({ data }) => {
        if (isCurrent) setUrl(data?.signedUrl ?? null);
      });
    return () => {
      isCurrent = false;
    };
  }, [path, bucket]);
  return path ? url : null;
};
